import React from 'react'
import { Box } from '@chakra-ui/react'

export const Td = React.forwardRef((props, ref) => {
  return <Box ref={ref} flex='1 0 auto' padding='0.5rem' {...props} />
})
